module.exports = __webpack_public_path__ + "img/ccdsjointop.f9d26a41.png";